import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { NotificationRequestViewModel } from '../../../business-entities/notification-details-result-view-model';
import { DashboardService } from '../../../business-services/dashboard.service';
import { NotificationViewComponent } from '../notification-view/notification-view.component';
import { Location } from '@angular/common'
import { TranslateService } from '@ngx-translate/core';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
@Component({
  selector: 'app-view-all-notifications',
  templateUrl: './view-all-notifications.component.html',
  styleUrls: ['./view-all-notifications.component.css']
})
export class ViewAllNotificationsComponent implements OnInit {
  notificationList: any = [];
  notificationPopupOpen: boolean = false;
  totalCount: number = 0;
  throttle = 100;
  scrollDistance = 1;
  notificationRequestModel: NotificationRequestViewModel =
    {
      userId: null,
      isRead: null,
      searchTerm: "",
      startRecordNo:0,
      numberOfRecord:20
    };
  constructor(
    private spinner: NgxSpinnerService,
    private dashboardService: DashboardService,
    private modalService: NgbModal,
    private userService: UserDataService,
    private _location: Location,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.notificationRequestModel.startRecordNo=0;
    this.notificationList=[];
    this.GetNotifications();
  }
 
  async GetNotifications() {
    this.spinner.show();
    this.userService.GetUserDetails().then(async (currentUser) => {
      const userId = currentUser?.userId;
      if (userId) {
        this.notificationRequestModel.userId = userId;
        this.notificationRequestModel.isRead = "ALL";
        await this.dashboardService.GetNotifications(this.notificationRequestModel).then((res)=>
        {
          if(res && res.length > 0){
            this.notificationList.push(...res);
            this.notificationList.forEach(element => {
              element.date = Utility.ConvertUTCDateToLocalDate(element.date)
            });
            this.totalCount=this.notificationList[0].totalCount;
           }else{
             this.totalCount=0;
           }
        }
        ).finally(() => {
          this.spinner.hide();
        });
      }
    });
  }
  
  onScrollDown(_ev) {
    if(this.notificationList?.length < this.totalCount){
      this.notificationRequestModel.startRecordNo = this.notificationList.length;
      this.GetNotifications();
    }
  }



  viewNotification(notification) {
    let modelHeadermsg=this.translate.instant("lblNotificationDetails");
    const modalRef = this.modalService.open(NotificationViewComponent, { size: 'lg' });
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.notificationList = notification;
    modalRef.result.then((_result) => {
      // This is intentional
     }, (_reason) => {
      if (!(notification.isRead)) {
        this.markAsRead(notification);
      }
    });
  }

  async markAsRead(notification) {
    this.spinner.show();
    const userId = this.userService.currentUserValue.userId;
    if (userId) {
      await this.dashboardService.notificationMarkAsRead(userId,notification.notificationId).then(response => {
        if (response) {
           notification.isRead=true;
           this.spinner.hide();
        }
      }).finally(() => {
        this.spinner.hide();
      });
    }
  }

  moveBack() {
    this._location.back();
  }
}



